import React from "react";
import checked from "./../../../../../Images/checked.png";

const StepByStepObtain = () => {
  return (
    <div className="blogWhat-content">
      <h5>4. Obtain the Necessary Licenses and Permits</h5>
      <p>
        Before launching your{" "}
        <a href="https://scentlifestyle.com/step-by-step-guide-to-setting-up-a-successful-salon-franchise-in-bangalore">
          salon franchise in Bangalore
        </a>
        , you need to obtain the necessary licenses and permits to operate
        legally. Failure to comply with local regulations can result in fines or
        business closures. The key licenses required for a salon franchise
        include:
      </p>
      <ul>
        <h4>Common Licenses Required:</h4>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Trade License:{" "}
          </span>
          <p>
            Issued by the local municipal corporation, this license allows you
            to operate your business legally.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            GST Registration:{" "}
          </span>
          <p>
            Since your salon will be providing taxable services, you’ll need to
            register for Goods and Services Tax (GST).
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Health and Safety License:{" "}
          </span>
          <p>
            Your salon must meet specific health and safety standards to protect
            customers and staff.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Fire Department Clearance:{" "}
          </span>
          <p>Ensure your salon complies with fire safety regulations.</p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Employment Contracts:{" "}
          </span>
          <p>
            If you hire staff, you will need proper employment agreements in
            place.
          </p>
        </li>
        <p>
          For instance, Scent, a leading salon franchise, offers comprehensive
          training, marketing support, and access to its well-known brand
          identity, making it a great option for franchisees in Bangalore.
        </p>
      </ul>

      <br />
    </div>
  );
};

export default StepByStepObtain;
